import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Button, Icon, Stack, Text } from '@/design-system'
import { FlowLayout } from '@/app/layouts/FlowLayout'
import { cn } from '@/lib/cn'
import { CARD_OPTIONS } from './onboarding-data'
import styles from './SelectCard.module.css'

export function OnboardingCard() {
  const navigate = useNavigate()
  const [selected, setSelected] = useState<string>('virtual')

  return (
    <FlowLayout
      step={2}
      totalSteps={3}
      back="/onboarding/accounts"
      footer={
        <>
          <Button size="lg" block onClick={() => navigate('/onboarding/ready')}>
            Continue
          </Button>
          <Button variant="ghost" size="md" block onClick={() => navigate('/onboarding/ready')}>
            Skip for now
          </Button>
        </>
      }
    >
      <Stack gap={6}>
        <Stack gap={2}>
          <Text as="h1" variant="title" weight="bold">
            Add a card
          </Text>
          <Text variant="body" tone="secondary">
            One payment, no monthly fee. Spend in any currency at 0.9% — and get 0.5% back on
            everything you buy.
          </Text>
        </Stack>

        <div className={styles.options}>
          {CARD_OPTIONS.map((option) => {
            const isOn = selected === option.id
            return (
              <button
                key={option.id}
                type="button"
                className={cn(styles.option, isOn && styles.selected, option.id === 'both' && styles.wide)}
                onClick={() => setSelected(option.id)}
                aria-pressed={isOn}
              >
                <Icon name={option.icon} size={24} />
                <Stack gap={1}>
                  <Stack direction="row" align="baseline" gap={2}>
                    <Text variant="caption" weight="semibold">
                      {option.title}
                    </Text>
                    <Text variant="eyebrow" weight="bold" tone="secondary">
                      {option.price}
                    </Text>
                  </Stack>
                  <Text variant="eyebrow" tone="secondary">
                    {option.body}
                  </Text>
                </Stack>
                <Icon
                  name={isOn ? 'check_circle' : 'radio_button_unchecked'}
                  size={20}
                  filled={isOn}
                  className={cn(styles.check, isOn && styles.checked)}
                />
              </button>
            )
          })}
        </div>
      </Stack>
    </FlowLayout>
  )
}
